<div class="row mt-3 mb-3">
  <div class="col-12">
    <button *ngIf="edicao" (click)="adicionarItem($event)" #btnAdicionar class="btn btn-sm btn-primary"
      title="Ctrl + I">
      <i class="fa fa-plus"></i> Incluir item
    </button>
    <button *ngIf="edicao" (click)="adicionarLote($event)" #btnAdicionarLote class="btn btn-sm btn-info ml-2"
      title="Ctrl + L">
      <i class="fa fa-plus"></i> Incluir lote
    </button>

    <button *ngIf="entidade.id" (click)="exportarMapaPreco()" class="btn btn-sm text-success p-0 float-right"
      title="Exportar Mapa de preço">
      <i class="far fa-share-square fa-2x"></i>
    </button>

    <div *ngIf="edicao" class="row float-right mr-2" style="width: 33%; border-right: 1px solid #dee2e6;">
      <div class="col-6 pr-0">
        <label class="m-0 mt-2 float-right">Redução Global</label>
      </div>
      <div class="col-6">
        <input [(ngModel)]="reducaoLanceGlobal" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control float-left text-right mt-1" style="width: calc(100% - 60px); height: 27px;"
          (keydown.enter)="salvarReducaoGlobal()" unmask="typed" [imask]="imaskConfig">
        <p-selectButton [options]="criteriosReducao" optionValue="id" [(ngModel)]="reducaoCriterioGlobal"
          [ngModelOptions]="{standalone: true}" class="float-right mt-1">
          <ng-template let-criterio>
            <span class="pl-2 pr-2">{{criterio.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <table class="table table-sm table-eddy">
      <thead>
        <tr>
          <th *ngIf="pregao" style="width: 20px">
            <input type="checkbox" [(ngModel)]="marcado" (click)="toggleSelecionado()">
          </th>
          <th *ngIf="pregao" style="width: 20px"></th>
          <th *ngIf="edicao" style="width: 20px"></th>
          <th style="width: 60px" scope="col">Ordem</th>
          <th scope="col">Item</th>
          <th style="width: 60px" class="text-center" scope="col">Unidade</th>
          <th style="width: 50px" scope="col">Qtde.</th>
          <th style="width: 75px" scope="col">Valor Ref.</th>
          <th *ngIf="edicao" style="width: 90px" scope="col">Redução</th>
          <th *ngIf="edicao" style="width: 140px" scope="col"></th>
        </tr>
      </thead>
      <tbody cdkDropList (cdkDropListDropped)="drop($event)">
        <tr *ngFor="let item of entidade.itens; let idx = index">
          <td *ngIf="edicao && !pregao" class="text-center" cdkDrag style="cursor: move;">
            <i *ngIf="!item.editavel" class="fa fa-bars" style="font-size: large;"></i>
          </td>
          <td *ngIf="!edicao && pregao" class="text-center">
            <input type="checkbox" [(ngModel)]="item.selecionado" [checked]="item.selecionado">
          </td>
          <td *ngIf="!edicao && pregao" class="text-center" cdkDrag style="cursor: move;">
            <i class="fa fa-sort" style="font-size: large;"></i>
          </td>

          <!-- ordem -->
          <td class="text-center">
            {{item.ordem}}
          </td>

          <!-- produto -->
          <td *ngIf="!item.editavelDescricao && !item.editavel">
            <span class="word-break-all" style="cursor: pointer;" (click)="alterarDescricao(item)"
              title="Clique para alterar a descrição do item">
              {{item.produto_unidade?.produto?.codigo}} {{funcaoService.abreviarStr(item.descricao, 100, true)}}
            </span>
          </td>
          <td *ngIf="!item.editavelDescricao && item.editavel && !item.lote">
            <p-autoComplete #produto_item_ id="rec" [(ngModel)]="produtoAtual" [forceSelection]="true"
              [autoHighlight]="true" [ngModelOptions]="{standalone: true}" [field]="produtoAutoComplete.conversor"
              [suggestions]="produtoAutoComplete.lista" (completeMethod)="produtoAutoComplete.filtrar($event)"
              (onSelect)="selecionarUnidade()" inputStyleClass="form-control form-control-sm" minLength="2"
              [style]="{ width: 'calc(100% - 32px)', float: 'left' }">
              <ng-template let-produto pTemplate="item">
                {{produto.codigo}} {{produto.nome}}
              </ng-template>
            </p-autoComplete>
            <button (click)="abrirConsultaProduto($event)" class="btn btn-sm btn-outline-secondary float-right"
              type="button" style="border-bottom-left-radius: 0px;  border-top-left-radius: 0px;"
              title="Busca avançada ou inclusão de novo produto/serviço (Ctrl + P).">
              <i class="fa fa-search-plus"></i>
            </button>
          </td>
          <td *ngIf="!item.editavelDescricao && item.editavel && item.lote">
            <input #nome_lote_ [(ngModel)]="item.descricao" [ngModelOptions]="{standalone: true}" type="text"
              class="form-control form-control-sm">
          </td>
          <td *ngIf="item.editavelDescricao">
            <textarea rows="5" #descricao_ [(ngModel)]="item.descricao" [ngModelOptions]="{standalone: true}"
              type="text" class="form-control form-control-sm" (keydown.enter)="salvarDescricao(item)"></textarea>
          </td>

          <!-- unidade -->
          <td *ngIf="!item.editavel" class="text-center">{{item.unidade}}</td>
          <td *ngIf="item.editavel && !item.lote">
            <select [compareWith]="compareFn" id="produto_unidade" [(ngModel)]="item.produto_unidade"
              [ngModelOptions]="{standalone: true}" class="form-control form-control-sm float-right"
              style="width: 100%;">
              <option [ngValue]="item" *ngFor="let item of produtoAtual?.unidades">
                {{item.unidade.nome}}
              </option>
            </select>
          </td>
          <td *ngIf="item.editavel && item.lote">
            <input [(ngModel)]="item.unidade" [ngModelOptions]="{standalone: true}" type="text"
              class="form-control form-control-sm">
          </td>

          <!-- quantidade -->
          <td *ngIf="!item.editavel || item.lote" class="text-right">{{+item.quantidade}}
          </td>
          <td *ngIf="item.editavel && !item.lote">
            <input #quantidade_ [(ngModel)]="item.quantidade" [ngModelOptions]="{standalone: true}" type="text"
              class="form-control form-control-sm" unmask="typed" [imask]="imaskQtd">
          </td>

          <!-- valor referencia -->
          <td *ngIf="!item.editavel" class="text-right">{{+item.valor_referencia | number:'1.4-4'}}</td>
          <td *ngIf="item.editavel" class="text-right">
            <input [(ngModel)]="item.valor_referencia" [ngModelOptions]="{standalone: true}" type="text"
              (keydown.enter)="salvar(item)" class="form-control form-control-sm" unmask="typed" [imask]="imaskConfig">
          </td>

          <!-- redução lances -->
          <td *ngIf="!item.editavelReducao && edicao" class="text-right">
            <span style="cursor: pointer;" (click)="alterarReducao(item)" title="Clique para alterar a redução do item">
              {{+item.reducao_lance | number:'1.4-4'}}
              <span class="badge badge-secondary">{{item.reducao_criterio === 'P' ? '%' : '$'}}</span>
            </span>
          </td>
          <td *ngIf="item.editavelReducao">
            <input #reducao_ [(ngModel)]="item.reducao_lance" [ngModelOptions]="{standalone: true}" type="text"
              (keydown.enter)="salvarReducao(item)" class="form-control form-control-sm" unmask="typed"
              [imask]="imaskConfig">
            <p-selectButton [options]="criteriosReducao" optionValue="id" [(ngModel)]="item.reducao_criterio"
              [ngModelOptions]="{standalone: true}">
              <ng-template let-criterio>
                <span class="pl-2 pr-2">{{criterio.nome}}</span>
              </ng-template>
            </p-selectButton>
          </td>

          <td *ngIf="edicao" class="text-right">
            <button *ngIf="!item.editavel && !item.produto_unidade" (click)="abrirItens(item)"
              class="btn btn-sm btn-outline-info mr-2" title="abrir itens">
              <i class="fa fa-cubes"></i>
            </button>
            <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
              <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
            </button>
            <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary">
              <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
            </button>
            <button *ngIf="!item.editavel" (click)="editar(item)" class="btn btn-sm btn-outline-primary mr-2">
              <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
            </button>
            <button *ngIf="!item.editavel" (click)="remover(item, idx)" class="btn btn-sm btn-outline-primary">
              <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<lib-produto-un-busca-dlg *ngIf="edicao" [login]="login" (callback)="callbackProdutoUn($event)">
</lib-produto-un-busca-dlg>
<app-memorial-item [login]="login" [memorial]=itemAtual></app-memorial-item>